import React from 'react'

const ErrorPage = () => {
  return (
    <div>Error, Not found</div>
  )
}

export default ErrorPage